import Link from 'next/link';

export default function ServerError({ episode }) {
  return (
    <div className="bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
          Ups! Wystąpił błąd.
        </h2>
        <p className="mt-6 text-lg leading-8 text-gray-600">Napisz nam o tym.</p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Link
            href="/contact"
            className="rounded-md bg-teal-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-teal-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600"
          >
            Napisz
          </Link>
          <Link href="/" className="text-sm font-semibold leading-6 text-gray-900">
            wróć na główną <span aria-hidden="true">→</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

ServerError.layout = 'Main';
